import { render, staticRenderFns } from "./usdtRecord.vue?vue&type=template&id=7cbb0b7c&scoped=true&"
import script from "./usdtRecord.vue?vue&type=script&lang=js&"
export * from "./usdtRecord.vue?vue&type=script&lang=js&"
import style0 from "./usdtRecord.vue?vue&type=style&index=0&id=7cbb0b7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbb0b7c",
  null
  
)

export default component.exports